import { createStore } from "vuex";

export default createStore({
  state: {
    isPinned: true,
    mcolor: "",
    isAbsolute: false,
    showSidenav: true,
    showMain: true,
    layout: "default",
    fingerprint: null,
    fingerprintComponents: null,
    fingerprintConfidence: null
  },
  mutations: {
    toggleSomeState(state) {
      if (state.someState === false) {
        state.someState = true;
      } else {
        state.someState = false;
      }
    }
  },
  actions: {
    toggleSidebarColor({ commit }, payload) {
      commit("sidebarType", payload);
    }
  },
  getters: {}
});
